import React from "react";
import autoBind from "react-autobind";

class GridFilterBase extends React.Component {
  constructor(props, inputs) {
    super(props);
    autoBind(this);
    this.inputs = inputs;
    this.mountInputs();
  }

  componentDidUpdate() {
    this.mountInputs();
  }

  updateContextColumn(column, save = true) {
    const { context } = this.props;
    const { columns } = context;
    this.updateIcon(column);
    columns[this.props.index] = column;
    context.setState({ columns }, save);
  }

  updateIcon(column) {
    let filterColumns = column.inputs.filter(x => x.value || x.value === 0 || (x.advancedSearchValues && x.advancedSearchValues.length != 0));
    column.isFiltered = filterColumns && filterColumns.length != 0;
  }

  mountInputs() {
    let { column } = this.props;
    if (!column.inputs || column.inputs.length == 0) {
      column.inputs = Object.keys(this.inputs).map(x => {
        let inputValues = this.inputs[x];
        return {
          ...inputValues,
          ...this.getDefaultInputValues(column)
        };
      });
      this.updateContextColumn(column);
    }
  }

  getDefaultInputValues(column) {}
}

export default GridFilterBase;
